(() => {
  const root = window.Shopify?.routes?.root || '/';
  const money = (cents) => new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format((cents || 0) / 100);
  const escapeHtml = (value = '') => String(value).replace(/[&<>'"]/g, (character) => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;'
  })[character]);

  function setupMenu() {
    const toggle = document.querySelector('[data-jwn-menu-toggle]');
    const menu = document.querySelector('[data-jwn-menu]');
    if (!toggle || !menu || toggle.dataset.ready) return;
    toggle.dataset.ready = 'true';

    const close = () => {
      toggle.classList.remove('isOpen');
      menu.classList.remove('isOpen');
      toggle.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('jwnNoScroll');
    };

    toggle.addEventListener('click', () => {
      const open = !menu.classList.contains('isOpen');
      toggle.classList.toggle('isOpen', open);
      menu.classList.toggle('isOpen', open);
      toggle.setAttribute('aria-expanded', String(open));
      document.body.classList.toggle('jwnNoScroll', open);
    });
    menu.querySelectorAll('a').forEach((link) => link.addEventListener('click', close));
  }

  function setupRails() {
    document.querySelectorAll('[data-jwn-rail]').forEach((rail) => {
      if (rail.dataset.ready) return;
      rail.dataset.ready = 'true';
      const track = rail.querySelector('[data-jwn-rail-track]');
      const move = (direction) => track?.scrollBy({ left: direction * Math.max(280, track.clientWidth * 0.78), behavior: 'smooth' });
      rail.querySelector('[data-jwn-rail-previous]')?.addEventListener('click', () => move(-1));
      rail.querySelector('[data-jwn-rail-next]')?.addEventListener('click', () => move(1));
    });
  }

  function setupSliderLightbox() {
    const lightbox = document.querySelector('[data-jwn-slider-lightbox]');
    if (!lightbox || lightbox.dataset.ready) return;
    lightbox.dataset.ready = 'true';

    const image = lightbox.querySelector('[data-jwn-slider-lightbox-image]');
    const closeButton = lightbox.querySelector('[data-jwn-slider-lightbox-close]');
    let previousFocus;

    const closeLightbox = () => {
      if (lightbox.hidden) return;
      lightbox.hidden = true;
      document.documentElement.classList.remove('jwnLightboxOpen');
      if (previousFocus instanceof HTMLElement) previousFocus.focus();
    };

    document.querySelectorAll('[data-jwn-slider-lightbox-trigger]').forEach((trigger) => {
      trigger.addEventListener('click', () => {
        const preview = trigger.querySelector('img');
        const source = preview?.currentSrc || trigger.dataset.src || preview?.src;
        if (!image || !source) return;
        previousFocus = document.activeElement;
        image.src = source;
        image.alt = trigger.dataset.alt || preview?.alt || '';
        lightbox.hidden = false;
        document.documentElement.classList.add('jwnLightboxOpen');
        closeButton?.focus();
      });
    });

    closeButton?.addEventListener('click', closeLightbox);
    lightbox.addEventListener('click', (event) => {
      if (event.target === lightbox) closeLightbox();
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !lightbox.hidden) closeLightbox();
    });
  }

  function setupGallery() {
    document.querySelectorAll('[data-jwn-gallery]').forEach((gallery) => {
      if (gallery.dataset.ready) return;
      gallery.dataset.ready = 'true';
      const main = gallery.querySelector('[data-jwn-gallery-main]');
      const thumbs = [...gallery.querySelectorAll('[data-jwn-gallery-thumb]')];
      const zoomTrigger = gallery.querySelector('[data-jwn-zoom-trigger]');
      const lightbox = gallery.querySelector('[data-jwn-lightbox]');
      const lightboxImage = gallery.querySelector('[data-jwn-lightbox-image]');
      const lightboxClose = gallery.querySelector('[data-jwn-lightbox-close]');
      let previousFocus;

      const closeLightbox = () => {
        if (!lightbox || lightbox.hidden) return;
        lightbox.hidden = true;
        document.documentElement.classList.remove('jwnLightboxOpen');
        if (previousFocus instanceof HTMLElement) previousFocus.focus();
      };

      const openLightbox = () => {
        if (!main || !lightbox || !lightboxImage) return;
        previousFocus = document.activeElement;
        lightboxImage.src = main.dataset.zoomSrc || main.currentSrc || main.src;
        lightboxImage.alt = main.alt;
        lightbox.hidden = false;
        document.documentElement.classList.add('jwnLightboxOpen');
        lightboxClose?.focus();
      };

      thumbs.forEach((thumb) => thumb.addEventListener('click', () => {
        if (!main) return;
        main.removeAttribute('srcset');
        main.src = thumb.dataset.src;
        main.dataset.zoomSrc = thumb.dataset.zoomSrc || thumb.dataset.src;
        main.alt = thumb.dataset.alt || '';
        thumbs.forEach((button) => {
          const selected = button === thumb;
          button.classList.toggle('selected', selected);
          button.setAttribute('aria-pressed', String(selected));
        });
      }));
      zoomTrigger?.addEventListener('click', openLightbox);
      lightboxClose?.addEventListener('click', closeLightbox);
      lightbox?.addEventListener('click', (event) => {
        if (event.target === lightbox) closeLightbox();
      });
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && lightbox && !lightbox.hidden) closeLightbox();
      });
    });
  }

  function setupTabs() {
    document.querySelectorAll('[data-jwn-tabs]').forEach((tabs) => {
      if (tabs.dataset.ready) return;
      tabs.dataset.ready = 'true';
      const buttons = [...tabs.querySelectorAll('[data-jwn-tab]')];
      const panels = [...tabs.querySelectorAll('[data-jwn-panel]')];
      buttons.forEach((button) => button.addEventListener('click', () => {
        const target = button.dataset.jwnTab;
        buttons.forEach((candidate) => {
          const active = candidate === button;
          candidate.classList.toggle('active', active);
          candidate.setAttribute('aria-selected', String(active));
        });
        panels.forEach((panel) => { panel.hidden = panel.dataset.jwnPanel !== target; });
      }));
    });
  }

  function setupDedications() {
    document.querySelectorAll('[data-jwn-dedication]').forEach((field) => {
      if (field.dataset.ready) return;
      field.dataset.ready = 'true';
      const counter = field.closest('.dedicationField')?.querySelector('[data-jwn-dedication-count]');
      field.addEventListener('input', () => { if (counter) counter.textContent = String(field.value.length); });
    });
  }

  function setupCartPage() {
    document.querySelectorAll('[data-jwn-cart-page-form]').forEach((form) => {
      if (form.dataset.ready) return;
      form.dataset.ready = 'true';
      const updateButton = form.querySelector('[name="update"]');
      let updateTimer;
      const submitUpdate = () => {
        window.clearTimeout(updateTimer);
        updateTimer = window.setTimeout(() => {
          if (updateButton) form.requestSubmit(updateButton);
          else form.requestSubmit();
        }, 420);
      };

      form.querySelectorAll('[data-jwn-quantity]').forEach((quantity) => {
        const input = quantity.querySelector('[data-jwn-quantity-input]');
        if (!input) return;
        quantity.querySelector('[data-jwn-quantity-minus]')?.addEventListener('click', () => {
          input.value = String(Math.max(0, Number(input.value || 0) - 1));
          submitUpdate();
        });
        quantity.querySelector('[data-jwn-quantity-plus]')?.addEventListener('click', () => {
          input.value = String(Math.max(0, Number(input.value || 0) + 1));
          submitUpdate();
        });
        input.addEventListener('change', () => {
          input.value = String(Math.max(0, Number(input.value || 0)));
          submitUpdate();
        });
      });
    });
  }

  function setupCart() {
    const drawer = document.querySelector('[data-jwn-cart-drawer]');
    const scrim = document.querySelector('.drawerScrim');
    if (!drawer || drawer.dataset.ready) return;
    drawer.dataset.ready = 'true';

    const itemsTarget = drawer.querySelector('[data-jwn-cart-items]');
    const footer = drawer.querySelector('[data-jwn-cart-footer]');
    const empty = drawer.querySelector('[data-jwn-cart-empty]');
    const total = drawer.querySelector('[data-jwn-cart-total]');
    const error = drawer.querySelector('[data-jwn-cart-error]');

    const setOpen = (open) => {
      drawer.classList.toggle('isOpen', open);
      scrim?.classList.toggle('isVisible', open);
      drawer.setAttribute('aria-hidden', String(!open));
      document.body.classList.toggle('jwnNoScroll', open);
    };

    const renderCart = (cart) => {
      document.querySelectorAll('[data-jwn-cart-count]').forEach((count) => {
        count.textContent = String(cart.item_count);
        count.hidden = cart.item_count === 0;
      });
      document.querySelectorAll('[data-jwn-cart-open]').forEach((button) => button.setAttribute('aria-label', `Warenkorb mit ${cart.item_count} Artikeln`));
      if (footer) footer.hidden = cart.item_count === 0;
      if (empty) empty.hidden = cart.item_count > 0;
      if (total) total.textContent = money(cart.total_price);
      if (!itemsTarget) return;

      itemsTarget.innerHTML = cart.items.map((item) => {
        const properties = Object.entries(item.properties || {})
          .filter(([, value]) => value)
          .map(([key, value]) => `${escapeHtml(key)}: ${escapeHtml(value)}`)
          .join('<br>');
        const details = [item.variant_title && item.variant_title !== 'Default Title' ? escapeHtml(item.variant_title) : '', properties]
          .filter(Boolean)
          .join('<br>');
        return `<div class="drawerProduct">
          ${item.image ? `<img src="${escapeHtml(item.image)}&width=182" alt="${escapeHtml(item.product_title)}" width="91" height="142">` : ''}
          <div class="drawerProductMeta">
            <h2>${escapeHtml(item.product_title)}</h2>
            <p>${details || 'Anzahl'} · ${item.quantity}</p>
            <strong>${money(item.final_line_price)}</strong>
          </div>
        </div>`;
      }).join('');
    };

    const refresh = async () => {
      const response = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('Der Warenkorb konnte nicht geladen werden.');
      const cart = await response.json();
      renderCart(cart);
      return cart;
    };

    document.querySelectorAll('[data-jwn-cart-open]').forEach((button) => button.addEventListener('click', async () => {
      setOpen(true);
      try { await refresh(); } catch (cartError) {
        if (error) { error.textContent = cartError.message; error.classList.add('isVisible'); }
      }
    }));
    document.querySelectorAll('[data-jwn-cart-close]').forEach((button) => button.addEventListener('click', () => setOpen(false)));
    document.addEventListener('keydown', (event) => { if (event.key === 'Escape') setOpen(false); });

    document.querySelectorAll('[data-jwn-product-form]').forEach((form) => {
      if (form.dataset.ready) return;
      form.dataset.ready = 'true';
      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        const submit = form.querySelector('[type="submit"]');
        const message = form.querySelector('[data-jwn-product-message]');
        if (submit) submit.disabled = true;
        if (message) message.textContent = '';
        if (error) error.classList.remove('isVisible');
        try {
          const response = await fetch(`${root}cart/add.js`, {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: new FormData(form)
          });
          if (!response.ok) {
            const payload = await response.json().catch(() => ({}));
            throw new Error(payload.description || 'Das Buch konnte nicht hinzugefügt werden.');
          }
          await refresh();
          setOpen(true);
        } catch (cartError) {
          if (message) message.textContent = cartError.message;
          else if (error) { error.textContent = cartError.message; error.classList.add('isVisible'); }
        } finally {
          if (submit) submit.disabled = false;
        }
      });
    });

    refresh().catch(() => {});
  }

  function initialize() {
    setupMenu();
    setupRails();
    setupSliderLightbox();
    setupGallery();
    setupTabs();
    setupDedications();
    setupCartPage();
    setupCart();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
